import { useMemo } from 'react';

import { Avatar, type AvatarProps } from '@mui/material';

import {
  isUploadcareUrl,
  optimizeUploadcareImg,
} from '@ll-platform/frontend/utils/helpers/uploadcare';

type PersonAvatarProps = AvatarProps & {
  size?: number;
};

export const PersonAvatar = ({
  src,
  size = 32,
  ...props
}: PersonAvatarProps) => {
  const avatarUrl = useMemo<string | null>(() => {
    const url = src;
    if (!url) {
      return null;
    }

    if (isUploadcareUrl(url)) {
      return optimizeUploadcareImg(url, size * 2);
    }

    return url;
  }, [src, size]);

  return (
    <Avatar
      color="primary"
      src={avatarUrl ?? undefined}
      slotProps={{
        img: {
          draggable: false,
        },
      }}
      {...props}
      sx={{
        width: size,
        height: size,
        background: (theme) => theme.palette.avatarFill,
        color: (theme) => theme.palette.primary.main,
        fontWeight: 600,
        fontSize: Math.floor(Math.min(size / 2.25, 24)),
        cursor: props.onClick ? 'pointer' : 'default',
        ...props.sx,
      }}
    />
  );
};
